import React, { useState } from 'react';
import axios from 'axios';

function AdminPanel() {
  const [result, setResult] = useState('');
  const [time, setTime] = useState('10:00'); // Default time
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]); // Default to today's date
  const [betData, setBetData] = useState(''); // Text input for bets
  const [aggregatedBets, setAggregatedBets] = useState([]); // Array to hold aggregated and sorted bet data

  // Function to handle bet data parsing, aggregation, and sorting
  const handleParseBets = () => {
    const betLines = betData.split('\n'); // Split the input into lines
    const bets = {};

    // Parse each line
    betLines.forEach(line => {
      const matches = line.match(/(\d+)(?:,(\d+))*(\(\d+\))/g); // Extract numbers and amounts
      if (matches) {
        matches.forEach(match => {
          const parts = match.split('('); // Split numbers and amounts
          const amount = parseInt(parts[1].replace(')', '')); // Extract amount
          const numbers = parts[0].split(',').map(num => parseInt(num.trim())); // Extract numbers

          // Aggregate bets for each number
          numbers.forEach(number => {
            if (bets[number]) {
              bets[number] += amount;
            } else {
              bets[number] = amount;
            }
          });
        });
      }
    });

    // Initialize array with numbers 0 to 100, default bet amount is 0 for each
    const allNumbers = Array.from({ length: 101 }, (_, i) => ({
      number: i,
      amount: bets[i] || 0,
    }));

    // Sort the array first by amount, then by number
    const sortedBets = allNumbers.sort((a, b) => {
      if (a.amount === b.amount) {
        return a.number - b.number; // Sort by number if amounts are the same
      }
      return a.amount - b.amount; // Sort by amount otherwise
    });

    setAggregatedBets(sortedBets);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://backend-af6u.onrender.com/addResult', { result, time, date });
      alert('Result added successfully!');
      setResult(''); // Clear the result input after submission
    } catch (error) {
      console.error('Error adding result', error);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">Admin Panel</h1>
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-lg p-6 max-w-md mx-auto space-y-4">
        <input
          type="number"
          placeholder="Enter result"
          value={result}
          onChange={(e) => setResult(e.target.value)}
          className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />

        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />

        <select
          value={time}
          onChange={(e) => setTime(e.target.value)}
          className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        >
          {/* Time slots from 10:00 AM to 5:00 PM in 15-minute intervals */}
          {Array.from({ length: 29 }, (_, i) => {
            const hours = Math.floor(i / 4) + 10;
            const minutes = (i % 4) * 15;
            const timeSlot = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            return <option key={i} value={timeSlot}>{timeSlot}</option>;
          })}
        </select>

        <button type="submit" className="bg-green-600 text-white p-3 rounded w-full">
          Submit Result
        </button>
      </form>

      <div className="bg-white shadow-md rounded-lg p-6 max-w-md mx-auto mt-8 space-y-4">
        <h2 className="text-xl font-bold text-center text-gray-800 mb-4">Paste Bet Data</h2>
        
        <textarea
          value={betData}
          onChange={(e) => setBetData(e.target.value)}
          placeholder="Paste the bets here in the format: 99,01,10,21,41,53,84,16,(10)"
          rows={6}
          className="w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        ></textarea>

        <button
          onClick={handleParseBets}
          className="bg-blue-500 text-white p-3 rounded w-full"
        >
          Parse and Sort Bets
        </button>

        {/* Display the aggregated and sorted results */}
        {aggregatedBets.length > 0 && (
          <div className="mt-4">
            <h3 className="text-lg font-bold text-gray-800">Parsed and Aggregated Bets:</h3>
            <ul className="list-disc pl-6">
              {aggregatedBets.map((bet, index) => (
                <li key={index} className="text-gray-700">
                  Number: {bet.number}, Total Amount: {bet.amount}₹
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPanel;
